/**
 * Scans Block.
 * (Used in PDPs)
 */

/**
 * Mobile: Slider with arrow(caret) nav.
 * Desktop: Click on scan highlights btn, displays scan content/info.
 */

 let
	$mySlider = $('.scans-block__scans'),
	mySliderSettings = {
		adaptiveHeight:false,
		arrows:true,
		appendArrows: $('.scans__arrow-nav'),
		// centerMode:true,
		// dots: false,
		fade: true,
		infinite: true,
		mobileFirst:true,
		slidesToShow:1,
		slidesToScroll:1,
		speed:300,
		swipe:false,
		swipeToSlide:false,
		variableWidth:false,
		responsive: [
			{
				// breakpoint: 699,
				// settings: {
				// 	slidesToShow:2,
				// 	slidesToScroll:2
				// }
			}
		]
	};

function initMobileSlider() {
	console.log('SCANS: initMobileSlider()');
	
	$mySlider.slick(mySliderSettings);
}

let
	$scans = $('.scans-block__scan');

function initDesktopClicks() {
	console.log('SCANS: initDesktopClicks()');

	$scans.on('click', function() {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
		} else {
			$scans.removeClass('active');
			$(this).addClass('active');
		}
	});
}

function removeDesktopClicks() {
	console.log('SCANS: removeDesktopClicks()');

	$scans.off();
}

let
	$window = $(window),
	prevWindowW = $window.width(),
	currWindowW = prevWindowW,
	breakpoint = 1024,
	sliderLayoutTimeout = undefined;

function initResizeWatcher() {
	console.log('SCANS: initResizeWatcher()');

	// Viewport width is mobile (< 1024).
	if (currWindowW < breakpoint) {
		initMobileSlider();
	}
	// Viewport width is desktop (>= 1024).
	if (currWindowW >= breakpoint) {
		initDesktopClicks();
	}
	
	$window.on('resize', function() {
		currWindowW = $window.width();

		// Viewport width is mobile (< 1024).
		if (currWindowW < breakpoint) {
		}

		// Viewport width is desktop (>= 1024).
		if (currWindowW >= breakpoint) {
		}

		// Viewport width crosses from mobile to desktop.
		if ((currWindowW >= breakpoint) && (prevWindowW < breakpoint)) {
			$mySlider.slick('unslick');
			initDesktopClicks();
		}
		// Viewport width crosses from desktop to mobile.
		if ((currWindowW < breakpoint) && (prevWindowW >= breakpoint)) {
			removeDesktopClicks();
			initMobileSlider();
		}

		prevWindowW = $window.width();
	});
}

exports.init = function () {
	// console.log('SCANS: exports.init');
	// Run init methods...

	initResizeWatcher();
};